<template>
  <div class="ActorNav" @click="toggleTree">
    <h1 class="ActorName" :class="cc">
      {{ actorName }}
    </h1>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import EventHub from '@/lib/eventHub'
import {Events} from '@/lib/definitions'

export default {
  name: 'ActorNav',
  components: {},
  computed: {
    ...mapGetters(['selectedActor', 'currentLandscape']),
    actorName() {
      return this.selectedActor
        ? this.selectedActor.name
        : this.currentLandscape.name
    },
    cc() {
      let color = this.selectedActor ? this.selectedActor.color : false
      if (!color) return `before:border-gray-900`
      else return `text-${color} before:bg-${color}`
    }
  },
  methods: {
    toggleTree() {
      EventHub.emit(Events.TOGGLE_TREE)
    }
  }
}
</script>

<style scoped>
.ActorNav {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 20px;
  height: 48px;
  border-bottom: 1px solid #dcdcdc;
  z-index: theme('zIndex.navMobile');
  background-color: white;
}
.ActorName {
  --actor-size: 15px;
  display: inline-flex;
  font-size: theme('fontSize.base');
  font-family: theme('fontFamily.mono');
  &:before {
    content: '';
    flex: none;
    width: var(--actor-size);
    height: var(--actor-size);
    margin-right: 12px;
    border: 2px solid;
    border-radius: 9999px;
  }
}
</style>
